module.exports = __webpack_public_path__ + "img/case-studies1.102df9b0.jpg";